import { createContext } from "react";

/** UI version type that determines which styles to render */
export type UIVersion = "v1" | "v2";

/** Context value type for the UI version context */
export interface UIVersionContextValue {
  /** The current UI version */
  uiVersion: UIVersion;
}

/**
 * React context for providing UI version throughout the component tree.
 *
 * This context allows v2 components to conditionally render v1 or v2 styles
 * based on the current UI version. Use the UIVersionProvider to set the version
 * and useUIVersion hook to consume the version.
 */
export const UIVersionContext = createContext<UIVersionContextValue>({
  uiVersion: "v2",
});
